import { DataCache, QueryResultsRelationship, ForeignKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { ReservationsInBatch } from 'data/models/ReservationsInBatch';
import { ReservationsListBaseCache } from 'portcall/reservationslistbase/cache';

export class ReservationsInBatchCache extends DataCache {
    ReservationsInBatches = PCCollection(ReservationsInBatch);

    constructor(data : PCCache, rowCache : ReservationsListBaseCache) {
        super();

        new ForeignKeyRelationship(data.RecurringBatches, this.ReservationsInBatches, null, r => r.Batch, r => r.BatchId());
        new ForeignKeyRelationship(data.Organizations,    this.ReservationsInBatches, null, r => r.Organization, r => r.OrganizationId());
        new QueryResultsRelationship(this.ReservationsInBatches, rowCache.ReservationsDashboardRows, r => r.Rows);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/reservationsinbatch/cache.ts